import React from 'react';
import styled from '@emotion/styled';
import { LinkContent } from '../partials';
import { LinkProps } from '../Link';
import { rem } from 'polished';

const StyledLink = styled(LinkContent)`
  svg {
    margin-left: ${rem(5)};
  }
`;

const LinkDownload = (props: LinkProps) => {
  return <StyledLink iconAfter="EchIconDownload" download {...props} />;
};

export default LinkDownload;
